import "./Badge.css"

function Badge({ children, className, variant = "default", ...props }) {
  const variantClass = variant === "outline" ? "badge-outline" : "badge-default"

  return (
    <span className={`badge ${variantClass} ${className || ""}`} {...props}>
      {children}
    </span>
  )
}

export default Badge

